import { default as common } from "./common.json";
import { default as dashboard } from "./dashboard.json";
import { default as registerCompany } from "./registerCompany.json";
import { default as orders } from "./orders.json";
import { default as settings } from "./settings.json";
import { default as trade } from "./trade.json";
import { default as contracts } from "./contracts.json";
import { default as commonAuction } from "./commonAuction.json";
import { default as charts } from "./charts.json";
import { default as statistics } from "./statistics.json";
import { default as staleTransactions } from "./staleTransactions.json";
import { default as validation } from "./validation.json";
import { default as commonComponents } from "./commonComponents.json";
import { default as tasks } from "./tasks.json";
import { default as commonAdmin } from "./commonAdmin.json";
import { default as claims } from "./claims.json";
import { default as notifications } from "./notifications.json";
import { default as enumerables } from "./enumerables.json";
import { default as product } from "./product.json";
import { default as actions } from "./actions.json";
import { default as navigation } from "./navigation.json";
import { default as company } from "./company.json";
import { default as weightReports } from "./weightReports.json";
import { default as commonOrders } from "./commonOrders.json";
import { default as containers } from "./containers.json";

const nb = {
  common,
  dashboard,
  registerCompany,
  orders,
  settings,
  trade,
  contracts,
  commonAuction,
  charts,
  company,
  statistics,
  staleTransactions,
  validation,
  commonComponents,
  tasks,
  commonAdmin,
  claims,
  notifications,
  enumerables,
  product,
  actions,
  navigation,
  commonOrders,
  weightReports,
  containers,
};

export default nb;
